function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 152,
    height: 153.415,
    viewBox: "0 0 152 153.415",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "prefix__Grupo_42",
    "data-name": "Grupo 42",
    transform: "translate(-3337.996 -2959.387)"
  }, React.createElement("g", {
    id: "prefix__Grupo_40",
    "data-name": "Grupo 40"
  }, React.createElement("path", {
    id: "prefix__Trazado_246",
    d: "M3402.8 2960.272a78.539 78.539 0 00-29.652 10.093c-1.434.837-2.839 1.682-4.258 2.52-3.145 1.858-5.639 4.906-8.3 7.363-2.814 2.594-5.551 5.386-8.17 8.111a36.029 36.029 0 00-7.061 11.973c-1.438 3.806-2.2 7.885-3.641 11.649-1.41 3.673-3.416 7.93-3.593 11.91-.2 4.551-.279 9.408.764 13.78.33 1.386.126 2.776.426 4.139a10.862 10.862 0 01.426 2.337 44.154 44.154 0 00.474 6.1 41.124 41.124 0 00.693 4.826c.5 1.876 1.286 3.729 1.872 5.589a51 51 0 002.135 5.621c.778 1.73 1.14 3.539 1.828 5.295a58.245 58.245 0 002.776 6.067 67.983 67.983 0 005.333 8.577 55.525 55.525 0 004.1 4.354 14.945 14.945 0 002.572 2.364c1.215.816 1.984 1.923 3.1 2.827a59.365 59.365 0 0012.65 7.394c4.563 2.1 8.992 5.045 13.941 6.441 2.351.664 4.693 1.058 7.033 1.758a23.58 23.58 0 005.986.872c1.521.043 2.9.574 4.444.574 1.664 0 3.14-.587 4.78-.564 3.11.042 6.611.453 9.661-.119 3.75-.7 7.309-1.81 11.063-2.69 1.8-.422 3.638-1.129 5.523-1.638a45.852 45.852 0 007.409-3.065 4.487 4.487 0 001.454-.827 7.774 7.774 0 012.237-1.742c1.247-.587 2.166-1.551 3.323-2.215 1.261-.723 2.573-1.426 3.886-2.1 1.867-.959 3.392-2.324 5.181-3.368 3.494-2.038 5.95-5.626 9.136-8.061 1.254-.958 2.155-2.576 3.185-3.8a25.042 25.042 0 003.408-5.06c1.747-3.69 3.178-7.468 4.82-11.184a40.325 40.325 0 001.719-5.011c.541-1.852 1.471-3.494 1.854-5.408 1.184-5.918 2.586-11.905 2.533-18-.027-3.1-.012-6.2-.012-9.3 0-3.148.326-6.557.027-9.692a30.894 30.894 0 00-1.134-5.935c-.231-.7-.731-1.3-1.016-2.016-.51-1.275-.814-2.659-1.391-3.909-1.8-3.9-3.6-8.208-6.031-11.718-7.823-11.278-15.853-23.887-28.257-30.1-7.109-3.559-15.084-4.649-22.928-5.324a119.671 119.671 0 00-26.308.312z",
    "data-name": "Trazado 246",
    style: {
      fill: "#de1c24"
    }
  })), React.createElement("g", {
    id: "prefix__Grupo_41",
    "data-name": "Grupo 41"
  }, React.createElement("path", {
    id: "prefix__Trazado_247",
    d: "M3419.62 3045.341c9.376-10.86 23.931-22.78 30.663-35.519l6.738-12.748-4.726-4.185-7.345-3.132-25.018 29.862c-7.1 8.48-48.526 50.1-48.462 52.649s4.151 6.243 5.692 8.095c2.475 2.975 4.23 2.594 7.017-.193 1.173-1.17 28.204-26.447 35.441-34.829z",
    style: {
      fill: "#fff"
    },
    "data-name": "Trazado 247"
  }), React.createElement("path", {
    id: "prefix__Trazado_248",
    d: "M3404.994 3041.719c10.86 9.375 22.781 23.93 35.519 30.662l12.749 6.738 4.185-4.726 3.132-7.345-29.862-25.018c-8.48-7.1-50.1-48.526-52.649-48.462s-6.244 4.152-8.1 5.693c-2.975 2.475-2.594 4.229.194 7.016 1.178 1.173 26.45 28.204 34.832 35.442z",
    style: {
      fill: "#fff"
    },
    "data-name": "Trazado 248"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.b300b00e.svg";
export { ForwardRef as ReactComponent };